export default __webpack_public_path__ + "media/images/images/elements/03-2cf990391d47249c3c88a7d1374cb368.png";